export default "__VITE_ASSET__rSH6pxgL__"